import { useState, useEffect } from 'react';
import IDealHeader from '@/finsight/ui/components/deals/DealsList/DealHeader/IDealHeader';
import LeadStructuring from '@/finsight/ui/components/deals/DealsList/DealHeader/Leads/LeadStructuring';
import LeadJoint from '@/finsight/ui/components/deals/DealsList/DealHeader/Leads/LeadJoint';
import LeadForEllipses from '@/finsight/ui/components/deals/DealsList/DealHeader/Leads/LeadForEllipses';

import styles from '@/finsight/ui/components/deals/DealsList/DealHeader/dealHeader.scss';

interface ILeadsProps {
  deal: IDealHeader,
  isLast: boolean,
  countInAbbr?: number,
}

const Leads = ({ deal, isLast, countInAbbr = 4 }: ILeadsProps) => {
  const [queryString, setQueryString] = useState(null);
  let structuringLeadsForAbbreviation = deal.structuringLeads.slice(0, countInAbbr);
  let structuringLeadsForEllipses = deal.structuringLeads.slice(countInAbbr);
  let jointLeadsForAbbreviation = [];
  let jointLeadsForEllipses = [];

  if (structuringLeadsForAbbreviation.length < countInAbbr) {
    jointLeadsForAbbreviation = deal.jointLeads.slice(0, (countInAbbr - structuringLeadsForAbbreviation.length));
    jointLeadsForEllipses = deal.jointLeads.slice(countInAbbr - structuringLeadsForAbbreviation.length);
  } else {
    jointLeadsForEllipses = [].concat(deal.jointLeads);
  }
  // @todo don't forget rewrite it after page filters migrate to context FIN-17372
  useEffect(() => {
    const { product, region } = deal;
    setQueryString(`?products=${ encodeURI(product.abbreviation) }&regions=${ encodeURI(region.abbreviation) }`);
  }, []);

  return (
    <div className={ styles.leadsCol } data-test="dealRowLeads">
      <LeadStructuring
        structuringLeadsForAbbreviation={ structuringLeadsForAbbreviation }
        jointLeadsForAbbreviation={ jointLeadsForAbbreviation }
        queryString={ queryString }
      />
      <LeadJoint
        jointLeadsForAbbreviation={ jointLeadsForAbbreviation }
        queryString={ queryString }
      />
      <LeadForEllipses
        structuringLeadsForEllipses={ structuringLeadsForEllipses }
        jointLeadsForEllipses={ jointLeadsForEllipses }
        isLast={ isLast }
      />
    </div>
  );
};

export default Leads;
